(() => {
  // src/js/themes/echo.js
  (function() {
    "use strict";
    setTimeout(() => {
      $(".loading-page").addClass("loading-page--hide");
      setTimeout(() => {
        $(".loading-page").removeClass("loading-page--before-hide");
        $(".loading-page").removeClass("loading-page--hide");
      }, 300);
    }, 1e3);
    $(".side-menu__link").on("click", function() {
      if ($(this).parent().find("ul").length) {
        if ($(this).parent().find("ul").first()[0].offsetParent !== null) {
          $(this).find(".side-menu__link__chevron").removeClass("transform rotate-180");
          $(this).removeClass("side-menu__link--active-dropdown");
          $(this).parent().find("ul").first().slideUp(300, function() {
            $(this).removeClass("side-menu__link__sub-open");
          });
        } else {
          $(this).find(".side-menu__link__chevron").addClass("transform rotate-180");
          $(this).addClass("side-menu__link--active-dropdown");
          $(this).parent().find("ul").first().slideDown(300, function() {
            $(this).addClass("side-menu__link__sub-open");
          });
        }
      }
    });
    // Initialize SimpleBar with proper element check
    const scrollableElement = $(".scrollable-ref").first()[0];
    if (scrollableElement && scrollableElement.nodeType === Node.ELEMENT_NODE) {
      try {
        new SimpleBar(scrollableElement);
      } catch (error) {
        // Only log in development mode
        if (window.dev_mode) {
          console.debug("SimpleBar initialization failed:", error.message);
        }
      }
    }
    // Silently skip if element not found (not all pages have scrollable elements)
    const backgroundMode = () => {
      if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        $(".background").first().addClass("background--hidden");
        $(".top-bar").first().addClass("top-bar--active");
        $(".content.mode").first().removeClass("mode--light");
      } else {
        $(".background").first().removeClass("background--hidden");
        $(".top-bar").first().removeClass("top-bar--active");
        $(".content.mode").first().addClass("mode--light");
      }
    };
    backgroundMode();
    window.onscroll = () => {
      backgroundMode();
    };
   const compactMenu = localStorage.getItem("compactMenu");
    if (compactMenu === null || compactMenu === "true") {
      localStorage.setItem("compactMenu", "true");
      $(".side-menu").first().addClass("side-menu--collapsed");
      $(".content").first().addClass("content--compact");
    } else {
      $(".side-menu").first().removeClass("side-menu--collapsed");
      $(".content").first().removeClass("content--compact");
    }
    $(".side-menu .side-menu__content").each(function() {
      $(this).on("mouseover", function() {
        $(".side-menu").first().addClass("side-menu--on-hover");
      });
    });
    $(".side-menu .side-menu__content").each(function() {
      $(this).on("mouseleave", function() {
        $(".side-menu").first().removeClass("side-menu--on-hover");
      });
    });
    $(".toggle-compact-menu").first().on("click", function(event) {
      event.preventDefault();
      const compactMenu2 = localStorage.getItem("compactMenu");
      if (compactMenu2 === null || compactMenu2 === "true") {
        localStorage.setItem("compactMenu", "false");
        $(".side-menu").first().removeClass("side-menu--collapsed");
        $(".content").first().removeClass("content--compact");
      } else {
        localStorage.setItem("compactMenu", "true");
        $(".side-menu").first().addClass("side-menu--collapsed");
        $(".content").first().addClass("content--compact");
      }
    });
    $(".open-mobile-menu").first().on("click", function(event) {
      event.preventDefault();
      $(".side-menu").first().addClass("side-menu--mobile-menu-open");
      $(".close-mobile-menu").first().addClass("close-mobile-menu--mobile-menu-open");
    });
    $(".close-mobile-menu").first().on("click", function(event) {
      event.preventDefault();
      $(".side-menu").first().removeClass("side-menu--mobile-menu-open");
      $(".close-mobile-menu").first().removeClass("close-mobile-menu--mobile-menu-open");
    });
    $(".request-full-screen").first().on("click", async function(event) {
      event.preventDefault();
      const el = document.documentElement;
      try {
        if (!document.fullscreenElement) {
          if (el.requestFullscreen) {
            await el.requestFullscreen();
          } else if (el.webkitRequestFullscreen) {
            await el.webkitRequestFullscreen();
          } else if (el.msRequestFullscreen) {
            await el.msRequestFullscreen();
          }
        } else {
          if (document.exitFullscreen) {
            await document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            await document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            await document.msExitFullscreen();
          }
        }
      } catch (error) {
        console.warn("Fullscreen API failed:", error.message);
        // Don't show error to user, just log it
      }
    });
    window.onresize = () => {
      $(".side-menu").first().removeClass("side-menu--mobile-menu-open");
      $(".close-mobile-menu").first().removeClass("close-mobile-menu--mobile-menu-open");
      
      if (window.innerWidth <= 768) {
        // Mobile view - force collapse
        localStorage.setItem("compactMenu", "true");
        $(".side-menu").first().addClass("side-menu--collapsed");
        $(".content").first().addClass("content--compact");
      } else {
        // Desktop view - restore saved state
        const compactMenu = localStorage.getItem("compactMenu");
        if (compactMenu === "true") {
          $(".side-menu").first().addClass("side-menu--collapsed");
          $(".content").first().addClass("content--compact");
        } else {
          $(".side-menu").first().removeClass("side-menu--collapsed");
          $(".content").first().removeClass("content--compact");
        }
      }
    };
  })();
})();
